import { useState } from 'react';
import MediaUploadComponent from '../media-library/media-upload.component';
import {
  Dialog,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Grid,
  Paper,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useToaster } from 'src/utils/toaster/toasterContext';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

export const GetPublicMediaUrl = ({ handleClose }) => {
  const theme = useTheme();
  const { t: translate } = useTranslation();

  const [mediaFiles, setMediaFiles] = useState([]);
  const { showToast } = useToaster();

  const handleMediaFiles = (files) => {
    setMediaFiles((prev) => [...prev, ...files]);
  };

  const handleCopy = (url) => {
    navigator.clipboard.writeText(url);
    showToast('Copied to clipboard!', 's');
  };

  const isMp4 = (file) => file.media_url?.toLowerCase().endsWith('.mp4') || file.media_type === 'video/mp4';

  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          minHeight: '300px',
          maxHeight: '90vh',
          height: '90vh',
        },
      }}
    >
      <DialogTitle>Upload media to get public URL</DialogTitle>
      <DialogContent>
        <Box p={3} minWidth={550}>
          <MediaUploadComponent handleMediaFiles={handleMediaFiles} isUploadToImageServer={true} />
          <Grid container spacing={2} mt={3}>
            {mediaFiles?.map((file, idx) => (
              <Grid item xs={4} key={idx}>
                <Paper sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box sx={{ position: 'relative', width: 220, height: 220, flexShrink: 0 }}>
                    {isMp4(file) ? (
                      <video
                        src={file.media_url}
                        controls
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: 4,
                          background: '#f0f0f0',
                        }}
                      />
                    ) : (
                      <img
                        src={file.media_url}
                        alt="media"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: 4,
                          background: '#f0f0f0',
                        }}
                      />
                    )}
                    <Tooltip title="Copy URL">
                      <IconButton
                        onClick={() => handleCopy(file.media_url)}
                        size="small"
                        sx={{
                          position: 'absolute',
                          bottom: 4,
                          right: 4,
                          background: 'white',
                          color: theme.palette.primary.main,
                          '&:hover': { background: theme.palette.primary.dark, color: 'white' },
                          cursor: 'pointer',
                        }}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.cancel', 'Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
